// src/Modals.js - CORREZIONE FINALE PER DIALOG TINYMCE

import React, { useState, useEffect, useRef } from 'react';
import moment from 'moment';
import { Editor } from '@tinymce/tinymce-react';
import { storage, db } from './firebase'; // Importa db
import { collection, getDocs } from 'firebase/firestore'; // Importa funzioni firestore
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { v4 as uuidv4 } from 'uuid';
import Select from 'react-select'; // Importa react-select
import { useUser } from './UserContext'; // Importa useUser per ottenere l'ID utente
import { FaFileDownload } from 'react-icons/fa';

const timeInputContainerStyles = {
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
    marginTop: '5px',
    justifyContent: 'center', // <-- CENTRA GLI INPUT HH:MM
};

const compactInputStyles = {
    width: '60px', /* Larghezza fissa per HH/MM */
    padding: '8px 5px',
    textAlign: 'center',
    boxSizing: 'border-box',
};
const compactLabelStyles = {
    display: 'block', 
    marginBottom: '5px',
    fontSize: '0.9rem',
    fontWeight: '500',
    color: '#555',
    textAlign: 'center', // <-- CENTRA IL TESTO SOPRA GLI INPUT TIME
};

const smallTimeInputStyles = {
    display: 'flex',
    gap: '15px',
    marginBottom: '15px',
    justifyContent: 'center', // <-- CENTRA GLI INPUT TIME (Inizio/Fine)
};

const ModalContainer = ({ children, onClose, className = '' }) => (
    <div className="modal" style={{ display: 'flex' }} onMouseDown={onClose}>
        <div className={`modal-content ${className}`} onMouseDown={e => e.stopPropagation()}>
            {children}
        </div>
    </div>
);

// src/Modals.js - SOSTITUISCI QUESTA FUNZIONE

export const ChangeShiftModal = ({ modalData, onConfirm, onClose, availableShifts = [] }) => { 
    const [shift, setShift] = useState('Mattina');
    const [overtime, setOvertime] = useState({ h: 0, m: 0 });
    const [leave, setLeave] = useState({ h: 2, m: 0 });
    const [customTime, setCustomTime] = useState({ start: '08:00', end: '12:00', pauseMinutes: 0 });
    const [recoveryTime, setRecoveryTime] = useState({ h: 1, m: 0 });

    useEffect(() => {
        let initialShiftValue = '';
        if (modalData?.shiftData) {
            const shiftData = modalData.shiftData;
            // Usa il nome originale se presente (per distinguere Mattina da Mattina REC ad es.)
            // altrimenti usa il nome principale.
            const currentShiftName = shiftData.originalName || shiftData.name;

            // Logica per casi speciali (Recupero Personalizzato, AggiungiRecupero)
            if (currentShiftName === 'Nuovo Orario' && (shiftData.recovery?.h > 0 || shiftData.recovery?.m > 0)) {
                initialShiftValue = 'AggiungiRecuperoPersonalizzato';
            } else if (shiftData.isRecovery && !shiftData.customTime && availableShifts.some(s => s.value === currentShiftName)) {
                 // Se è un recupero E non custom time E il nome esiste nelle opzioni (es. Mattina REC)
                 initialShiftValue = currentShiftName; // Usa direttamente il nome REC se esiste
            } else if (shiftData.isRecovery && !shiftData.customTime) {
                 initialShiftValue = 'AggiungiRecupero'; // Fallback se nome REC non esiste come timeslot
            } else {
                 initialShiftValue = currentShiftName; // Valore di base
            }

            // Popola gli altri campi come prima
            setOvertime(shiftData.overtime || { h: 0, m: 0 });
            setLeave(shiftData.leave && (shiftData.leave.h > 0 || shiftData.leave.m > 0) ? shiftData.leave : { h: 2, m: 0 });
            setCustomTime(shiftData.customTime || { start: '08:00', end: '12:00', pauseMinutes: 0 });
            setRecoveryTime(shiftData.recovery || { h: 1, m: 0 });

        } else if (availableShifts.length > 0){
             // Se è un nuovo inserimento, prova a pre-selezionare "Mattina" o la prima opzione disponibile
             const defaultOption = availableShifts.find(s => s.value === 'Mattina') || availableShifts[0];
             initialShiftValue = defaultOption?.value || '';
        }
        setShift(initialShiftValue);

    }, [modalData, availableShifts]); // Riesegui se cambiano i dati o le opzioni

    // Determina quali campi extra mostrare in base alla selezione
    const showOvertime = shift === 'Straordinario';
    const showLeave = shift === 'Permesso';
    const isAddingRecoveryPersonalizzato = shift === 'AggiungiRecuperoPersonalizzato';
    const showCustomTime = shift === 'Nuovo Orario' || isAddingRecoveryPersonalizzato;
    const showRecoveryTimeInput = isAddingRecoveryPersonalizzato;

    const handleConfirm = () => {
        let finalShiftName = shift;
        let finalCustomTime = showCustomTime ? customTime : null;
        let finalRecoveryTime = { h: 0, m: 0 }; // Default

        // Se è Recupero Personalizzato, salva come "Nuovo Orario" ma con i dati di recupero
        if (isAddingRecoveryPersonalizzato) {
            finalShiftName = 'Nuovo Orario';
            finalRecoveryTime = { h: parseInt(recoveryTime.h) || 0, m: parseInt(recoveryTime.m) || 0 };
        }

        onConfirm({
            ...modalData, // Contiene person e dayStr
            newShiftName: finalShiftName,
            overtime: showOvertime ? { h: parseInt(overtime.h) || 0, m: parseInt(overtime.m) || 0 } : { h: 0, m: 0 },
            leave: showLeave ? { h: parseInt(leave.h) || 0, m: parseInt(leave.m) || 0 } : { h: 0, m: 0 },
            customTime: finalCustomTime,
            recovery: finalRecoveryTime,
        });
    };

    const displayOptions = availableShifts;
    const selectedShiftOption = availableShifts.find(option => option.value === shift);

    return (
        <ModalContainer onClose={onClose}>
            <h3>Cambia Turno / Inserisci</h3>
            <p>Modifica per <b>{modalData.person}</b> il {moment(modalData.dayStr).format('DD/MM/YYYY')}</p>

            {/* --- SELECT DINAMICO --- */}
            <Select
                options={availableShifts} // Usa le opzioni passate
                value={selectedShiftOption} // Imposta l'oggetto opzione selezionato
                onChange={(selectedOption) => setShift(selectedOption ? selectedOption.value : '')} // Aggiorna lo stato 'shift' con il valore
                placeholder="Seleziona turno..."
                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} // Per evitare problemi di sovrapposizione
                menuPortalTarget={document.body} // Renderizza nel body
                classNamePrefix="react-select" // Per eventuale styling custom
            />
            
            {showOvertime && (
                <div style={{ marginTop: '15px' }}>
                    <h4>Straordinari (HH:MM)</h4>
                    <div style={timeInputContainerStyles}>
                        <input type="number" value={overtime.h} onChange={e => setOvertime({...overtime, h: parseInt(e.target.value) || 0})} min="0" placeholder="HH" style={compactInputStyles}/>
                        <span>:</span>
                        <input type="number" value={overtime.m} onChange={e => setOvertime({...overtime, m: parseInt(e.target.value) || 0})} min="0" step="15" placeholder="MM" style={compactInputStyles}/>
                    </div>
                </div>
            )}

             {showLeave && (
                <div style={{ marginTop: '15px' }}>
                    <h4>Permesso (HH:MM)</h4>
                    <div style={timeInputContainerStyles}>
                        <input type="number" value={leave.h} onChange={e => setLeave({...leave, h: parseInt(e.target.value) || 0})} min="0" placeholder="HH" style={compactInputStyles}/>
                        <span>:</span>
                        <input type="number" value={leave.m} onChange={e => setLeave({...leave, m: parseInt(e.target.value) || 0})} min="0" step="15" placeholder="MM" style={compactInputStyles}/>
                    </div>
                </div>
            )}

            {showCustomTime && (
                <div style={{ marginTop: '15px' }}>
                    <h4>{isAddingRecoveryPersonalizzato ? 'Orario di Lavoro (con Recupero)' : 'Nuovo Orario'}</h4>
                    <div style={smallTimeInputStyles}>
                        <div>
                            <label style={compactLabelStyles}>Inizio</label>
                            <input type="time" value={customTime.start} onChange={e => setCustomTime({...customTime, start: e.target.value })} />
                        </div>
                        <div>
                            <label style={compactLabelStyles}>Fine</label>
                            <input type="time" value={customTime.end} onChange={e => setCustomTime({...customTime, end: e.target.value })} />
                        </div>
                    </div>
                    {/* 🆕 Pausa opzionale, in minuti — viene sottratta dalle ore ordinarie di questa fascia */}
                    <div style={{ marginTop: '10px' }}>
                        <label style={compactLabelStyles}>Pausa (minuti, opzionale)</label>
                        <input
                            type="number"
                            min="0"
                            step="5"
                            placeholder="Es. 30"
                            value={customTime.pauseMinutes || 0}
                            onChange={e => setCustomTime({...customTime, pauseMinutes: parseInt(e.target.value) || 0 })}
                            style={compactInputStyles}
                        />
                    </div>
                </div>
            )}

            {showRecoveryTimeInput && (
                <div style={{ marginTop: '15px', border: '1px solid #ffc107', padding: '10px', borderRadius: '5px' }}>
                    <h4>Ore di Recupero Da Segnare (HH:MM)</h4>
                    <div style={timeInputContainerStyles}>
                        <input type="number" value={recoveryTime.h} onChange={e => setRecoveryTime({...recoveryTime, h: parseInt(e.target.value) || 0})} min="0" placeholder="HH" style={compactInputStyles}/>
                        <span>:</span>
                        <input type="number" value={recoveryTime.m} onChange={e => setRecoveryTime({...recoveryTime, m: parseInt(e.target.value) || 0})} min="0" step="15" placeholder="MM" style={compactInputStyles}/>
                    </div>
                </div>
            )}

            {/* Pulsanti Conferma/Annulla (invariati) */}
            <div>
                <button onClick={handleConfirm} className="modal-button confirm-button" style={{ marginTop: '20px' }}>Conferma</button>
                <button onClick={onClose} className="modal-button cancel-button">Annulla</button>
            </div>
        </ModalContainer>
    );
};

export const ConfirmationModal = ({ title, children, onConfirm, onClose }) => (
    <ModalContainer onClose={onClose}>
        <h3>{title}</h3>
        {children}
        <div>
            <button onClick={onConfirm} className="modal-button confirm-button">Sì, Conferma</button>
            <button onClick={onClose} className="modal-button cancel-button">Annulla</button>
        </div>
    </ModalContainer>
);

export const ChoiceModal = ({ title, children, choices, onChoice, onClose }) => (
    <ModalContainer onClose={onClose}>
       <h3>{title}</h3>
       {children}
       <div>
           {choices.map(choice => (
               <button
                   key={choice.label} // Risolve l'avviso della "key"
                   onClick={() => {
                       // Controlla se il singolo pulsante ha una sua "action"
                       if (typeof choice.action === 'function') {
                           choice.action();
                       } 
                       // Altrimenti, usa la funzione generica "onChoice"
                       else if (typeof onChoice === 'function') {
                           onChoice(choice.value);
                       }
                   }}
                   className={`modal-button ${choice.className || 'neutral-button'}`}
               >
                   {choice.label}
               </button>
           ))}
            <button onClick={onClose} className="modal-button cancel-button">Annulla</button>
       </div>
   </ModalContainer>
);


// src/Modals.js
// ... (tutti gli altri componenti Modal come ChangeShiftModal, ConfirmationModal, ecc. restano invariati) ...

export const ProcedureModal = ({ procedureData, categories, onSave, onClose }) => {
    const { userProfile } = useUser();
    const [title, setTitle] = useState('');
    const [categoryId, setCategoryId] = useState('');
    const [content, setContent] = useState('');
    const editorRef = useRef(null);
    const [visibility, setVisibility] = useState('all');
    const [sharedWith, setSharedWith] = useState([]);
    const [staffOptions, setStaffOptions] = useState([]);
    const isMobile = window.innerWidth <= 768;

    const [selectedFile, setSelectedFile] = useState(null);
    const [existingFileUrl, setExistingFileUrl] = useState('');
    const [existingFileName, setExistingFileName] = useState('');

    // --- 1. AGGIUNGI STATO PER IL NUOVO FLAG ---
    const [hideOnMobile, setHideOnMobile] = useState(false);
    // --- FINE 1 ---

    useEffect(() => {
    const fetchStaff = async () => {
        if (!userProfile || !userProfile.centerId) return; 
        const staffSnapshot = await getDocs(collection(db, 'centers', userProfile.centerId, 'staff'));
        const options = staffSnapshot.docs
                .map(doc => ({ value: doc.id, label: doc.data().name }))
                .filter(option => option.value !== userProfile?.uid)
                .sort((a, b) => a.label.localeCompare(b.label));
            setStaffOptions(options);
        };
        fetchStaff();
    }, [userProfile?.uid, userProfile]); // Aggiunta dipendenza userProfile

    useEffect(() => {
        if (procedureData) {
            setTitle(procedureData.title || '');
            setCategoryId(procedureData.categoryId || '');
            if (procedureData.fileUrl) {
                setContent(''); 
                setExistingFileUrl(procedureData.fileUrl);
                setExistingFileName(procedureData.fileName || 'documento');
            } else {
                setContent(procedureData.content || '');
                setExistingFileUrl('');
                setExistingFileName('');
            }
            setVisibility(procedureData.visibility || 'all');
            
            // --- 2. CARICA IL FLAG ESISTENTE ---
            setHideOnMobile(procedureData.hideOnMobile || false); // Default a false se non esiste
            // --- FINE 2 ---
            
            if (procedureData.visibility === 'shared' && procedureData.sharedWith && staffOptions.length > 0) {
                 const selectedUsers = staffOptions.filter(option =>
                    procedureData.sharedWith.includes(option.value)
                 );
                 setSharedWith(selectedUsers);
            } else {
                 setSharedWith([]);
            }
        } else {
            setTitle('');
            setCategoryId(categories.length > 0 ? categories[0].id : '');
            setContent('');
            setVisibility('all');
            setSharedWith([]);
            setExistingFileUrl('');
            setExistingFileName('');
            
            // --- 3. IMPOSTA DEFAULT PER NUOVI DOC ---
            setHideOnMobile(false); // Default a 'false' (visibile)
            // --- FINE 3 ---
        }
    }, [procedureData, categories, staffOptions]);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setSelectedFile(file);
        setExistingFileUrl('');
    };

    const handleSave = () => {
        const currentContent = editorRef.current ? editorRef.current.getContent() : content;
        
        if (title.trim() === '' || categoryId === '') {
            alert('Titolo e Categoria sono obbligatori.');
            return;
        }
        if (!selectedFile && !existingFileUrl && currentContent.trim() === '') {
             alert('Devi inserire un Contenuto Testuale o caricare un File.');
             return;
        }
        if (visibility === 'shared' && sharedWith.length === 0) {
            alert('Se scegli "Condiviso con specifici utenti", devi selezionare almeno un utente.');
            return;
        }

        onSave({
            id: procedureData?.id,
            title: title.trim(),
            categoryId,
            content: (selectedFile || existingFileUrl) ? '' : currentContent, 
            selectedFile: selectedFile,
            existingFileUrl: existingFileUrl,
            visibility: visibility,
            sharedWith: visibility === 'shared' ? sharedWith.map(user => user.value) : [],
            ownerId: procedureData?.ownerId || userProfile?.uid,
            centerId: userProfile?.centerId,
            
            // --- 4. PASSA IL NUOVO FLAG AL SALVATAGGIO ---
            hideOnMobile: hideOnMobile
            // --- FINE 4 ---
        });
    };
    
    // ... (filePickerCallback rimane invariato) ...
    const filePickerCallback = (callback, value, meta) => {
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'image/*');

        input.onchange = async () => {
            const file = input.files[0];
            if (!file) return;
            const fileName = `${uuidv4()}-${file.name}`;
            const storageRef = ref(storage, `procedure_images/${fileName}`);
            try {
                const snapshot = await uploadBytes(storageRef, file);
                const downloadURL = await getDownloadURL(snapshot.ref);
                callback(downloadURL, { alt: file.name });
            } catch (error) {
                console.error("Errore upload immagine:", error);
            }
        };
        input.click();
    };

    return (
        <ModalContainer onClose={onClose} className="modal-content-large">
            <h3>{procedureData ? 'Modifica Documento' : 'Nuovo Documento'}</h3>
            <div style={{ textAlign: 'left', marginTop: '15px', display: 'flex', flexDirection: 'column', gap: '15px' }}>
                {/* Titolo e Categoria (invariati) */}
                 <div>
                    <label htmlFor="proc-title">Titolo</label>
                    <input id="proc-title" type="text" value={title} onChange={(e) => setTitle(e.target.value)} />
                </div>
                 <div>
                    <label htmlFor="proc-category">Categoria</label>
                    <select id="proc-category" value={categoryId} onChange={(e) => setCategoryId(e.target.value)}>
                        <option value="" disabled>Seleziona una categoria</option>
                        {categories.map(cat => (
                            <option key={cat.id} value={cat.id}>{cat.name}</option>
                        ))}
                    </select>
                </div>
                {/* Campo File (invariato) */}
                <div>
                    <label>Carica File (PDF, DOCX, XLSX, ecc.)</label>
                    <input type="file" onChange={handleFileChange} disabled={!!existingFileUrl && !selectedFile} />
                    {/* ... (logica 'existingFileUrl' e 'selectedFile' invariata) ... */}
                </div>
                
                {/* Sezione Visibilità (invariata) */}
                 <div>
                    <label>Visibilità Documento</label>
                    <div className="visibility-options-container">
                        {/* ... (radio button 'all', 'private', 'shared' invariati) ... */}
                        <input type="radio" id="vis-all" name="visibility" value="all" checked={visibility === 'all'} onChange={(e) => setVisibility(e.target.value)} />
                        <label htmlFor="vis-all">🌍 Tutti</label>
                        <input type="radio" id="vis-private" name="visibility" value="private" checked={visibility === 'private'} onChange={(e) => setVisibility(e.target.value)} />
                        <label htmlFor="vis-private">🔒 Solo io</label>
                        <input type="radio" id="vis-shared" name="visibility" value="shared" checked={visibility === 'shared'} onChange={(e) => setVisibility(e.target.value)} />
                        <label htmlFor="vis-shared">🤝 Condiviso con...</label>
                    </div>
                </div>
                {visibility === 'shared' && (
                    <div>
                        <label htmlFor="proc-shared-with">Condividi con:</label>
                        <Select
                            id="proc-shared-with"
                            isMulti options={staffOptions} value={sharedWith}
                            onChange={setSharedWith} placeholder="Seleziona utenti..."
                            styles={{ menuPortal: base => ({ ...base, zIndex: 99999 }) }}
                            menuPortalTarget={document.body}
                        />
                    </div>
                )}
                
                {/* --- 5. AGGIUNGI LA CHECKBOX UI --- */}
                <div className="form-group-checkbox" style={{marginTop: '10px', padding: '10px', backgroundColor: '#f8f9fa', borderRadius: '5px'}}>
                    <label>
                        <input
                            type="checkbox"
                            checked={hideOnMobile}
                            onChange={(e) => setHideOnMobile(e.target.checked)}
                        />
                        Nascondi sull'App Mobile Dipendenti
                    </label>
                </div>
                {/* --- FINE 5 --- */}

                {/* Editor TinyMCE (invariato) */}
                 <div>
                    <label>Contenuto</label>
                    <Editor
                        apiKey={process.env.REACT_APP_TINYMCE_API_KEY}
                        onInit={(evt, editor) => editorRef.current = editor}
                        initialValue={content}
                        init={{
                            height: isMobile ? 300 : 400,
                            menubar: false,
                            plugins: 'anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
                            toolbar: 'undo redo | blocks | bold italic underline strikethrough | link image media table | align | numlist bullist indent outdent | emoticons charmap | removeformat',
                            file_picker_types: 'image',
                            file_picker_callback: filePickerCallback,
                            content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
                            z_index: 99998,
                        }}
                    />
                </div>
            </div>
            {/* Pulsanti (invariati) */}
            <div>
                <button onClick={handleSave} className="modal-button confirm-button" style={{ marginTop: '20px' }}>
                    {procedureData ? 'Salva Modifiche' : 'Crea Documento'}
                </button>
                <button onClick={onClose} className="modal-button cancel-button">Annulla</button>
            </div>
        </ModalContainer>
    );
};


export const SimpleViewModal = ({ modalData, onClose }) => {
    return (
        <div className="modal" onMouseDown={onClose}>
            <div className="modal-content modal-content-large" onMouseDown={e => e.stopPropagation()}>
                <h3 style={{ borderBottom: '1px solid #eee', paddingBottom: '10px' }}>{modalData.title}</h3>
                
                <div style={{ maxHeight: '70vh', overflowY: 'auto', padding: '10px 0' }}>
                    {modalData.fileUrl ? (
                         <div style={{ textAlign: 'center', padding: '50px 0' }}>
                            <p style={{fontSize: '1.1rem', marginBottom: '20px'}}>
                                Questo documento è un file: <strong>{modalData.fileName || 'Documento Esterno'}</strong>
                            </p>
                            <a href={modalData.fileUrl} target="_blank" rel="noopener noreferrer" className="modal-button confirm-button" style={{ textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '10px' }}>
                                <FaFileDownload /> Scarica Documento
                            </a>
                        </div>
                    ) : (
                        <div dangerouslySetInnerHTML={{ __html: modalData.content }} />
                    )}
                </div>

                <div style={{ marginTop: '20px' }}>
                    <button onClick={onClose} className="modal-button neutral-button">Chiudi</button>
                </div>
            </div>
        </div>
    );
};
